<div class="main-content" id="main-content">
  <section id="breadcrumbs">
    <div class="container-lg">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <app-breadcrumb [breadcrumbItems]="breadcrumbItems"></app-breadcrumb>
        </div>
      </div>
    </div>
  </section>

  <section id="page">
    <div class="container-lg">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div id="page-title" class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h2>{{ eixo.nome }}</h2>
            </div>
          </div>

          <!-- Imagem e descrição do eixo -->
          <div id="page-intro" class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <p>
                <img
                  class="img-responsive"
                  src="assets/comprimidas/{{ eixo.id }}/{{ eixo.imagem }}"
                  alt="{{ eixo.nome }}"
                />
              </p>
              <p>{{ eixo.descricao }}</p>
            </div>
          </div>

          <!-- Áreas tecnolócicas com decrição -->
          <div id="page-areas" class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h2>
                Áreas Tecnológicas
                <a
                  class="toggle-collapsed"
                  (click)="toggleCollapse()"
                  [attr.aria-expanded]="isCollapsed"
                  aria-controls="collapseArea"
                >
                  <i class="fas fa-chevron-down fa-lg" *ngIf="!isCollapsed"></i>
                  <i class="fas fa-chevron-up fa-lg" *ngIf="isCollapsed"></i>
                </a>
              </h2>

              <div class="collapse" [ngClass]="{ show: isCollapsed }">
                <div class="row">
                  <div
                    class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
                    *ngFor="let area of areasTecnologicas"
                  >
                    <h4 class="area-title">{{ area.nome }}</h4>
                    <p>{{ area.descricao }}</p>
                  </div>
                  <div
                    class="col-xs-12 col-sm-6 col-md-6 col-lg-6"
                    *ngIf="msgSemArea"
                  >
                    <!-- <h4 class="area-title">{{ area.nome }}</h4> -->
                    <p>{{ msgSemArea }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div id="page-subtitle" class="row">
            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
              <h3>Cursos</h3>
            </div>
          </div>

          <!-- Filtro eixo e área tecnológica -->
          <app-barra-busca
            [areas]="areasTecnologicas"
            [componenteRef]="componenteRef"
            (inputEvent)="recebeuInput($event)"
            [filtroArea]="true"
            [filtros]="false"
            [mensagem]="mensagem"
            [msgSemArea]="msgSemArea"
          >
          </app-barra-busca>

          <div id="results" *ngFor="let curso of cursos">
            <div class="row articles">
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <app-card
                  [titulo]="curso.nome"
                  [texto]="curso.perfilProfissional"
                  [id]="curso.id"
                  [tipo]="curso.status"
                >
                </app-card>
              </div>
            </div>
          </div>

          <app-paginacao
            *ngIf="totalResultados"
            [paginaAtual]="paginaAtual"
            [totalPaginas]="totalPaginas"
            (mudouPagina)="onPaginaSelecionada($event)"
          >
          </app-paginacao>
        </div>
      </div>
    </div>
  </section>
</div>
